import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Element, scroller } from 'react-scroll';
import cx from 'classnames';
import ListItem from './ListItem';
import * as styles from './AnchorList.scss';

// NOTE do not use as a plain component
export default class AnchorList extends Component {
  state = {
    active: __CLIENT__ && !!location.hash && location.hash.slice(1)
  };

  setActive = (key) => {
    if (global && global.history) {
      const urlWithHash = location.pathname + location.search + (key ? `#${key}` : '');
      this.setState(
        { active: key },
        // Warning: can cause history state management bugs
        () => {
          global.history.replaceState(null, null, urlWithHash);
          if (this.props.onSelectionChange) {
            this.props.onSelectionChange(key);
          }
          setTimeout(() => scroller.scrollTo(key, { smooth: true, offset: -50 }), 200);
        }
      );
    }
  };

  renderListItem = (data) => {
    const ListComponent = this.props.listComponent || ListItem;
    const isActive = this.state.active === data.key;
    const onClose = () => {
      if (isActive) { setTimeout(this.setActive(''), 100); }
    };
    const onOpen = () => {
      this.setActive(data.key);
    };
    const afterInitialOpen = isActive
      ? () => { setTimeout(scroller.scrollTo(data.key, { smooth: true, offset: -50 }), 100); }
      : null;

    return (
      <li key={data.key} className={styles.wrapper}>
        <Element name={data.key}>
          <ListComponent
            {...data}
            isActive={isActive}
            className={cx(styles.accordion, this.props.listComponentClassName)}
            onOpen={onOpen}
            onClose={onClose}
            afterInitialOpen={afterInitialOpen}
            content={this.localRequire[this.props.locale](`./${data.fileName}`)}
          />
        </Element>
      </li>
    );
  };

  render() {
    if (!__CLIENT__) {
      return null;
    }
    return (
      <ul className={cx(styles.anchorList, this.props.className)}>
        {this.props.children}
        {this.props.dataList.map(this.renderListItem)}
      </ul>
    );
  }
}

AnchorList.propTypes = {
  dataList: PropTypes.array.isRequired,
  listComponent: PropTypes.node,
  locale: PropTypes.string,
  className: PropTypes.string,
  listComponentClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  onSelectionChange: PropTypes.func
};

AnchorList.defaultProps = {
  children: []
};
